import { ArrowUp, ArrowDown, Minus, Sparkle } from "lucide-react";

// Tiny trend pill: ▲ +12.1% / ▼ -5.4% / — flat / ✦ new.
// Props:
//   direction: "up" | "down" | "flat" | "new"
//   pct: number | null  (null when direction === "new")
//   size: "xs" (default) | "sm"
//   showIcon: boolean (default true)
//   title: optional tooltip text
//   testId
export function TrendChip({ direction = "flat", pct, size = "xs", showIcon = true, title, testId }) {
  const tone = {
    up:   "bg-[#E3F0E6] text-[#1F6336]",
    down: "bg-[#F5E3E0] text-[#A13E34]",
    flat: "bg-[#F0F0EC] text-[#737A76]",
    new:  "bg-[#FFF4D4] text-[#946A00]",
  }[direction] || "bg-[#F0F0EC] text-[#737A76]";

  const Icon = direction === "up" ? ArrowUp
    : direction === "down" ? ArrowDown
    : direction === "new" ? Sparkle
    : Minus;

  const sizeCls = size === "sm"
    ? "text-[11px] px-2 py-0.5 gap-1"
    : "text-[10px] px-1.5 py-0.5 gap-0.5";
  const iconSize = size === "sm" ? 11 : 10;

  let label;
  if (direction === "new") label = "new";
  else if (direction === "flat") label = "0%";
  else if (pct === null || pct === undefined) label = "—";
  else {
    const sign = pct > 0 ? "+" : "";
    label = `${sign}${pct.toFixed(1)}%`;
  }

  return (
    <span
      className={`inline-flex items-center rounded-full font-medium tabular-nums ${tone} ${sizeCls}`}
      title={title || `Last 7d vs prior 7d: ${label}`}
      data-testid={testId}
      data-direction={direction}
    >
      {showIcon && <Icon size={iconSize} strokeWidth={2.4} />}
      {label}
    </span>
  );
}
